<div class="gridLayout">
	<sim-labelled-container label="CREATE_SESSION_DIALOG_CREATE_SESSION" icon="fa-cube">
		<!--TITLE-->
		<mat-form-field color="accent">
			<mat-label>
				<mat-icon fontIcon="fa-signature" fontSet="fad" />
				{{ T.CREATE_SESSION_DAILOG_SESSION_NAME | translate }}
			</mat-label>
			<input [formControl]="store.metadataForm.controls.title" matInput />
		</mat-form-field>

		<!--DATE-->
		<mat-form-field class="full-width-form" color="accent">
			<mat-label>
				<mat-icon fontIcon="fa-calendar-day" fontSet="fad" />
				{{ T.LABEL_DATE | translate }}
			</mat-label>
			<input
				(click)="datepicker.open()"
				[formControl]="store.metadataForm.controls.date"
				[matDatepicker]="datepicker"
				[max]="eventEndDate()"
				[min]="eventStartDate()"
				matInput
				readonly
			/>
			<mat-error>
				{{ T.ERROR_INVALID | translate: {item: T.LABEL_DATE | translate} }}
			</mat-error>
			<mat-datepicker-toggle [for]="datepicker" matIconSuffix>
				<mat-icon color="accent" fontIcon="fa-calendar-day" fontSet="fad" matDatepickerToggleIcon />
			</mat-datepicker-toggle>
			<mat-datepicker #datepicker />
		</mat-form-field>

		<!--START TIME-->
		<sim-clock-time-input [formCtrl]="store.metadataForm.controls.startTime" [labelKey]="T.SHARED_EVENT_SESSION_ESTIMATED_TIME_START" />
	</sim-labelled-container>
	<mat-divider vertical />
	<sim-list [floatingLabel]="true" class="stationList" icon="fa-cubes" label="CREATE_SESSION_DIALOG_LIST_OF_STATIONS">
		<ng-container actions>
			<sim-new-list-item
				(add)="store.stationAdded()"
				[disabled]="store.metadataForm.invalid || store.stationForms.invalid"
				buttonLabel="BUTTON_CREATE"
				class="default"
				primaryLabel="CREATE_SESSION_DIALOG_NEW_STATION"
			/>
		</ng-container>
		@for (station of store.stationForms.controls; track $index) {
			@let isValid = station?.valid;
			<sim-list-item
				(click)="store.stationSelected($index)"
				indicator="{{ $index + 1 }}"
				[selected]="store.activeStationIndex() === $index"
				[primaryLabel]="isValid ? station.value?.trainingRoom?.name : (T.CREATE_SESSION_DIALOG_STATION_LIST_ITEM_EMPTY | translate)"
				[secondaryLabel]="isValid ? station.value?.scenario?.name : null"
				[invalid]="!isValid"
			>
				<ng-container actions>
					<button appStopPropagation mat-icon-button color="warn" (click)="store.stationDeleted($index)">
						<mat-icon fontSet="fas" fontIcon="fa-trash-alt" inline />
					</button>
				</ng-container>
			</sim-list-item>
		}
	</sim-list>
	<sim-labelled-container icon="fa-cube" label="CREATE_SESSION_DIALOG_STATION_CONFIG">
		@let activeStationForm = store.activeStationForm();
		@if (activeStationForm) {
			@if (!isFormCooldown()) {
				<!--TRAINING ROOM-->
				<sim-chip-autocomplete
					[formCtrl]="activeStationForm.controls.trainingRoom"
					[dataType]="FetchDataType.TrainingRoom"
					[labelToken]="T.CREATE_SESSION_DIALOG_TRAINING_ROOM_LABEL"
					[excludeIds]="excludeRoomIds()"
				>
					<ng-container labelPrefix>
						<mat-icon fontIcon="fa-door-open" fontSet="fad" />
					</ng-container>
				</sim-chip-autocomplete>

				<!--SCENARIO-->
				<sim-chip-autocomplete
					[formCtrl]="activeStationForm.controls.scenario"
					[dataType]="FetchDataType.Scenario"
					[labelToken]="T.CREATE_SESSION_DIALOG_SCENARIO_SELECTION_LABEL"
					[excludeIds]="excludeScenarioIds()"
				>
					<ng-container labelPrefix>
						<mat-icon fontIcon="fa-cube" fontSet="fad" />
					</ng-container>
				</sim-chip-autocomplete>
			} @else {
				<div class="emptyState secondary">
					<mat-spinner color="accent" />
				</div>
			}
		} @else {
			<div class="emptyState secondary">
				<mat-icon fontIcon="fa-empty-set" fontSet="far" />
				<label>{{ T.GENERAL_TXT_LIST_EMPTY | translate }}</label>
			</div>
		}
	</sim-labelled-container>
</div>
